/**
 * MilestoneFlowTags — what the compressed chain left on a milestone (docs/COMPRESSED_CHAIN.md):
 *   StartedAheadTag  "started ahead of the IDP" while that predecessor is still open; hover gives
 *                    who, when and why. Shown on the outline row and the zoom title.
 *   PostRecordTag    on a posted milestone: "posted with the Client Review" and/or the meeting whose
 *                    posted minutes hold the client's approval.
 * Both read outline/milestoneFlow.js (one firm-wide index) and render nothing when there is nothing.
 */
import { startedAheadOf, postRecordOf } from '../outline/milestoneFlow.js'
import { ctx } from '../outline/ctx.js'

function msName(id) {
  const lists = [ctx.state && ctx.state.milestones]
  if (ctx.milestonesCache) for (const k of Object.keys(ctx.milestonesCache)) lists.push(ctx.milestonesCache[k])
  for (const l of lists) if (Array.isArray(l)) for (const m of l) if (m && m.id === id) {
    return { name: String(m.fields['Full Deliverable Name'] || m.fields['Name'] || 'a predecessor').replace(/\s*🔄\s*/g, ' ').trim(), posted: !!m.fields['Posted Date'] }
  }
  return { name: 'a predecessor', posted: false }
}
const day = (iso) => iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : ''

const tagStyle = { fontFamily: '"DM Sans",sans-serif', fontSize: 11.5, color: '#b8540a', marginLeft: 8, whiteSpace: 'nowrap' }

export function StartedAheadTag({ msId, style }) {
  const rows = startedAheadOf(msId).map(r => ({ ...r, pred: msName(r.predecessor_airtable_id) })).filter(r => !r.pred.posted)
  if (!rows.length) return null
  const title = rows.map(r => `Started ahead of ${r.pred.name} · ${r.by_name || 'a firm leader'} · ${day(r.created_at)}: ${r.reason}`).join('\n')
  return (
    <span className="wf-started-ahead-tag" title={title} style={{ ...tagStyle, ...style }}>
      started ahead of {rows.map(r => r.pred.name).join(', ')}
    </span>
  )
}

export function PostRecordTag({ msId, style }) {
  const r = postRecordOf(msId)
  if (!r || (!r.posted_with_name && !r.meeting_label)) return null
  const bits = []
  if (r.posted_with_name) bits.push('posted with ' + r.posted_with_name)
  if (r.meeting_label) bits.push('approved in ' + r.meeting_label)
  const title = [bits.join(' · '), r.approval_quote ? '“' + r.approval_quote + '”' : '', r.note || '', r.by_name ? '· ' + r.by_name : ''].filter(Boolean).join('\n')
  return <span title={title} style={{ ...tagStyle, color: 'var(--aj-text-muted)', ...style }}>{bits.join(' · ')}</span>
}
